<template>
  <div class="content">
    <p>7月4日14时许，吉林省松原市宁江区繁华路巷路施工过程中造成燃气泄漏，燃气公司在抢修时发生爆炸，爆炸引发松原市医院氧气瓶爆炸，两次爆炸叠加效应导致市医院成为这次爆炸的重灾区。事故共造成5人死亡，89人受伤，其中重伤员14人。</p>
    <div class="imgbox">
      <img src="../../assets/images/airsep/xinwen2.png" alt="">
      <img src="../../assets/images/airsep/xinwen1.png" alt="">
    </div>
    <p>"当时大家都被吓懵了。" 松原市中西医结合医院宣传科科长李志峰回忆，爆炸地点就在与该院老院区（人民院区）一墙之隔的胡同，相距不足50米。该院老院区共有医护人员和患者近500人，部分患者和医护人员在爆炸中受伤，"主要是烧伤和骨折"</p>
  </div>
</template>

<script>
export default {
  name: 'TabJilinAccident'
}
</script>

<style lang="scss" scoped>
.content{
  font-size: 18px;
  color: #6a6a6a;
  p{
    font-size: 18px;
    line-height: 36px;
    text-indent:40px;
  }
  .imgbox{
    margin: 20px 0px;
  }
}
</style>
